<template>
<body id="page-top" class="member-page-body">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio member-page-section" id="portfolio">
            <div class="container">
                 <!-- <div>    
                   <div class="mb-3 row">
                         <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">Select Case No.</label>
                            <div class="col-sm-10">
                              <input readonly autocomplete="off" placeholder="Tap here to select a LOA to print." style="width:90%;" v-b-modal.modal-center v-model="CaseNo" class="form-control" id="exampleFormControlTextarea1" type="search" aria-label="Search" required>
                            </div>
                            <div>-->
                        <!--<b-button style="float:right; margin-top:25px;" v-b-modal.modal-center type="button" class="btn btn-primary btn-lg">SEARCH</b-button>-->
                        

                        <!--<b-modal id="modal-center" class="preview-modal" ref="preview-modal">
                            <div>
                            <a v-if="LOAlist.length == 0" style="font-size:30px;"></a>
                            <a v-else-if="LOAlist.length != 0" href="#" class="list-group-item list-group-item-action" v-for="item in LOAlist" :key="item.CaseNo" @click="preview(item)">
                            {{item.CaseNo}}<br>
                            {{item.DateCreated}}<br>
                            {{item.ServiceType}}
                          </a>
                            </div>
                        </b-modal>
                        </div>
                       </div>
              </div>-->
                <div class="row justify-content-center loa-form">
                    <div class="login-form">
                      <div  v-if="step === 0" >
                         <iframe :src="LOAurl" crossorigin="anonymous" id="loaprint" ref="loaprint"></iframe>
                         </div>

                    <div v-if="step === 1">
                      <p class="lead custom-notice option-notice">
                                Do you have other transactions?
                                <router-link to="/member-page"><button class="btn btn-primary btn-lg yes-no-option">YES</button></router-link>
                                <button class="btn btn-primary btn-lg yes-no-option" @click='logOut'>NO</button>
                            </p>
                    </div>
                    </div>

      
                    
                       <div id="print-hidden" class="col-md-12" style="padding-top: 25px;">
                  <button @click="print()" type="button" style="margin-right: 10px;" class="btn btn-primary btn-lg" onClick="this.disabled=true" >PRINT</button>
                  <button @click="nextStep" class="btn btn-primary btn-lg" :disabled="step == 1">NEXT</button>
            </div>
                </div>
        </div>
        </section>
            <div class='spinner load' v-if='loading'><img src="../assets/phil-care-loading-logo.gif"/></div>
</body>
</template>


<script>
import axios from 'axios';
export default {
  name: 'DoctorName',
  data() {
    return {
      certNo: '',
      TokenID: '',
      LastName: '',
      FirstName: '',
      Doctors: [],
      LOAurl:'',
      LOAlist:[],
      CaseNo:'',
      error:true,
      loading: false,
      step: 0,
     
    }
  },
  /*created() {
      console.log(localStorage.key(0));
      if (localStorage.getItem('CertNo') === null) {
          this.$router.push('/login');
      }
      if (localStorage.getItem('CertNo') ) {
          this.CertNo = localStorage.getItem('CertNo')
          this.LOAurl = 'https://apps.philcare.com.ph/ITGPortal/ViewCurrentKioskLOA.aspx?CertNo='+this.CertNo;
          //this.LOAurl = 'https://apps.philcare.com.ph/ITGPortalTest/ViewCurrentKioskLOA.aspx?CertNo='+this.CertNo;
      }
    },*/

  async created() {
      this.loading = true
      this.certNo = localStorage.getItem('CertNo')
        
        
        const response = await axios.post('/api/?action=save-loa-preview', {
           CertNo: this.certNo
           
         }, 
        );
        this.loading = false
        if (localStorage.getItem('CertNo') === null) {
          this.$router.push('/login');
      }
        console.log(response);
        //this.PlanBenefitsHTML=response.data.PlanBenefitsHTML;
        //this.ProviderAccessHTML=response.data.ProviderAccessHTML;
        //this.StatusHTML=response.data.StatusHTML;
        //this.LOAlist=response.data;
        //this.CaseNo=response.data[0].CaseNo;
        //this.LOAurl = 'https://apps.philcare.com.ph//ITGPortalTest//GenerateLOA.aspx?CaseNo='+response.data[0].CaseNo;
        //this.LOAurl = 'https://apps.philcare.com.ph/ITGPortal/GenerateLOA.aspx?CaseNo='+response.data[0].CaseNo;
          this.LOAurl = response.data.loaURL+"#toolbar=0";
    },

  methods: {
   /* preview(item) {
            //this.LOAurl = 'https://apps.philcare.com.ph//ITGPortalTest//GenerateLOA.aspx?CaseNo='+item.CaseNo;
            this.LOAurl = 'https://apps.philcare.com.ph/ITGPortal/GenerateLOA.aspx?CaseNo='+item.CaseNo;
          this.CaseNo=item.CaseNo;
          this.hideModal()
    },
    hideModal() {
            this.$refs['preview-modal'].hide();
            },*/
    print() {
    var iframe = document.getElementById("loaprint")
    iframe.contentWindow.focus();       
    iframe.contentWindow.print(); 
      },

    nextStep(){
      this.step = this.step+1
      //console.log(this.step, this.loginType);
      //if (this.loginType=="firstCons" && this.step == 3){
       // this.handleSubmit()
      //}
    },
    
    logOut() {
        localStorage.removeItem('CertNo');
        localStorage.removeItem('allowLOAConsult');
        localStorage.removeItem('allowLOALab');
        this.$router.push('/login');

    }
    
  }
  }



</script>
<style>
.modal-content {
  height: 50%;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
